import React from 'react'
import { DropdownMenu } from 'shared/components/DropdownMenu'

export const ActionMenuCellRenderer = ({ actionItemsGetter, ...rest }) => {
  return <DropdownMenu items={actionItemsGetter(rest)} />
}
